import React, { Fragment } from 'react'
import { Division, RealEstateDataPageComponentData } from 'types'
import { Container } from 'react-bootstrap'
import { Link } from 'gatsby'
import { ElementHTML } from '@helpers/helper.rendering'

interface ExternalProps {
  divisions: Division[]
  three: Division[]
}

const PreHome_1 = ({
  title,
  image,
  global_data,
  three,
  arrayImages,
  paragraph,
  paragraphElement,
  paragraphHexa,
  titleElement,
  titleHexa,
  alignCenter,
  opacityValue,
  height,
  logoSize,
  backgroundHexa,
}: ExternalProps & RealEstateDataPageComponentData) => {
  const { logo, logoMobile } = global_data

  console.log(logoSize)

  const getCurrentYear = () => new Date().getFullYear()
  return (
    <div className="preHome a prehome_banner">
      <div
        className={'opacity '}
        style={{
          background: backgroundHexa || '#f1f1f1',
          opacity:
            opacityValue && opacityValue !== '0'
              ? Number(opacityValue) !== 100
                ? `0.${Number(opacityValue)}`
                : 1
              : 0.6,
        }}
      ></div>
      <nav
        style={{
          height: height?.desktop ? height?.desktop + 'px' : '7vh',
        }}
      >
        <Container fluid>
          {arrayImages?.length === 0 || arrayImages === null ? (
            <div className={'d-flex w-100 ' + (alignCenter ? 'justify-content-center' : '')}>
              <img
                src={logo}
                alt=""
                className="d-none d-lg-block"
                height={
                  logoSize && height?.desktop
                    ? (parseInt(height?.desktop) * parseInt(logoSize)) / 100 + 'px'
                    : '80px'
                }
                style={{
                  maxHeight:
                    logoSize && height?.desktop
                      ? (parseInt(height?.desktop) * parseInt(logoSize)) / 100 + 'px'
                      : '4.5vh',
                }}
              />
              <img
                height={
                  logoSize && height?.desktop
                    ? (parseInt(height?.desktop) * parseInt(logoSize)) / 100 + 'px'
                    : '80px'
                }
                style={{
                  maxHeight:
                    logoSize && height?.desktop
                      ? (parseInt(height?.desktop) * parseInt(logoSize)) / 100 + 'px'
                      : '4.5vh',
                }}
                src={logoMobile}
                alt=""
                className="d-block justify-content-center mx-auto d-lg-none"
              />
            </div>
          ) : (
            <div className={'d-flex w-100 ' + (alignCenter ? 'justify-content-center' : '')}>
              {arrayImages &&
                arrayImages.map((image, index) => (
                  <img
                    src={image.image}
                    key={index}
                    height={
                      logoSize && height?.desktop
                        ? (parseInt(height?.desktop) * parseInt(logoSize)) / 100 + 'px'
                        : '80px'
                    }
                    style={{
                      maxHeight:
                        logoSize && height?.desktop
                          ? (parseInt(height?.desktop) * parseInt(logoSize)) / 100 + 'px'
                          : '4.5vh',
                    }}
                    className="mx-5"
                    alt={'imagen-' + index}
                  />
                ))}
            </div>
          )}
        </Container>
      </nav>
      <img
        src={image}
        alt=""
        className="w-100 h-100 background-image position-absolute no-border"
      />
      <div className="d-flex flex-column w-100 index-top">
        {title?.split('\n').map((line, index) => (
          <ElementHTML
            elementType={titleElement || 'h1'}
            key={index}
            className="title-element"
            style={{ color: titleHexa }}
          >
            {line}
          </ElementHTML>
        ))}
        {paragraph && (
          <div className="mt-3 mx-auto paragraph-container">
            {paragraph?.split('\n').map((para, index) => (
              <ElementHTML
                className="paragraph-element"
                elementType={paragraphElement || 'p'}
                key={index}
                style={{ color: paragraphHexa }}
              >
                {para}
              </ElementHTML>
            ))}
          </div>
        )}
      </div>

      <div className="bottom index-top">
        <div className="nav-branches">
          {three.map(({ path, title }, index) => (
            <Fragment key={index}>
              {index ? <h5 className="v-line text-white mb-0"> | </h5> : ''}
              <Link
                to={path}
                className="text-decoration-none"
              >
                <h5 className="title-link text-center text-white text-uppercase px-5 mb-0">
                  {title}
                </h5>
              </Link>
            </Fragment>
          ))}
        </div>
        <div className="copy-footer mt-5 d-none d-lg-block">
          Promoted by{' '}
          <a
            target="_blank"
            href="https://mediahaus.com.ar"
          >
            MediaHaus
          </a>{' '}
          - Powered by{' '}
          <a
            target="_blank"
            href="https://mediacore.app/"
          >
            MediaCore
          </a>{' '}
          - Todos los derechos reservados ® {getCurrentYear()}
        </div>
      </div>
      <div className="copy-footer mt-5 d-block d-lg-none">
        Promoted by{' '}
        <a
          target="_blank"
          href="https://mediahaus.com.ar"
        >
          MediaHaus
        </a>{' '}
        - Powered by{' '}
        <a
          target="_blank"
          href="https://mediacore.app/"
        >
          MediaCore
        </a>{' '}
        <br /> Todos los derechos reservados ® {getCurrentYear()}
      </div>
    </div>
  )
}

export default PreHome_1
